import { render, staticRenderFns } from "./RepublishNotification.vue?vue&type=template&id=9e114f20&scoped=true"
import script from "./RepublishNotification.vue?vue&type=script&lang=js"
export * from "./RepublishNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e114f20",
  null
  
)

export default component.exports